import { useQuery, UseQueryResult } from 'react-query';
import { InvoiceRetrieve } from 'types';
import { client } from 'utils/api-client';

function useInvoice(invoiceId: string | undefined): UseQueryResult<{ data: InvoiceRetrieve }> {
  return useQuery(['invoices', invoiceId], () => client.get(`invoices/${invoiceId}/`), {
    enabled: !!invoiceId,
  });
}

export default useInvoice;
